module.exports = __webpack_public_path__ + "delete.cfdbafe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/feeds/delete.png
// module id = 904
// module chunks = 0